import dayjs from 'dayjs';

export default function (value) {
    const date = dayjs(value, 'DD/MM/YYYY HH:mm', true);
    return date.isValid();
}
